import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import content from 'prismic-translates/dialog-invite-friends.json'
import { useAppSelector } from 'store/hooks'
import { sweepstakeEnabledSelector } from 'store/modules/appConfig/selectors'
import { getUserInvitationInfoSelector } from 'store/modules/user/selectors'
import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

export default function ReferFriendData() {
  const invitationInfo = useAppSelector(getUserInvitationInfoSelector)
  const { isDarkMode } = useThemeContext()
  const isSCEnabled = useAppSelector(sweepstakeEnabledSelector)
  const t = getTranslationFromJson([content])

  return (
    <div className={cx(classes.root, isDarkMode && classes.rootDarkMode)}>
      <div className={classes.dataContainer}>
        <span className={cx('mt-typography-body2', classes.title, isDarkMode && classes.titleDarkMode)}>
          {t('sc_invite_friends_invited')}
        </span>
        <span className={cx('mt-typography-body2', classes.earnValue)}>{invitationInfo.invited}</span>
      </div>
      <div className={classes.dataContainer}>
        <span className={cx('mt-typography-body2', classes.title, isDarkMode && classes.titleDarkMode)}>
          {t('sc_invite_friends_qualified')}
        </span>
        <span className={cx('mt-typography-body2', classes.earnValue)}>{invitationInfo.purchasesQualified}</span>
      </div>
      <div className={classes.dataContainer}>
        <span className={cx('mt-typography-body2', classes.title, isDarkMode && classes.titleDarkMode)}>
          {t('sc_invite_friends_rewards_earned')}
        </span>
        <span className={cx('mt-typography-body2', cx(classes.earnValue, isSCEnabled && classes.earnValueSC))}>
          SC {invitationInfo.sweepstake}
        </span>
      </div>
    </div>
  )
}
